import axios from "axios";

// 统一 API 客户端 —— 所有请求以 /api 为前缀，由 Vite proxy 转发至后端
const apiClient = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  timeout: 30000,
});

// 请求拦截：所有请求自动携带 agent_token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("agent_token");
  if (token) {
    config.headers.token = token;
  }
  return config;
});

// 响应拦截：统一提取后端 Message 结构
apiClient.interceptors.response.use(
  (response) => {
    const data = response.data as ApiMessage;
    if (data && data.success === false) {
      return Promise.reject(new Error(data.info || "请求失败"));
    }
    return response;
  },
  (error) => {
    if (error.response) {
      const data = error.response.data as ApiMessage;
      if (data?.info) {
        return Promise.reject(new Error(data.info));
      }
    }
    return Promise.reject(error);
  }
);

/** 后端 Message 结构 */
export interface ApiMessage {
  id: string;
  success: boolean;
  info: string;
  num: number;
  memo: string;
  data: unknown;
}

export default apiClient;
